/**
 * Thin adapter: Admin Cover Prompt → noso-packaging skill (source of truth).
 * Do not duplicate palette/flavor/process maps here.
 */
import { buildCoverPrompt, skillData } from '@noso-packaging/prompt-builder.ts'

export { buildCoverPrompt, buildPrompt, skillData } from '@noso-packaging/prompt-builder.ts'
// skill path: .cursor/skills/noso-packaging/ (Vite alias @noso-packaging)

const PROCESS_ENUM = { natural: '日晒', washed: '水洗', honey: '蜜处理', other: '其他' }

function splitMulti(raw) {
	if (!raw) return []
	if (Array.isArray(raw)) return raw.map((x) => String(x).trim()).filter(Boolean)
	return String(raw)
		.split(/[/、,，+;|]+/)
		.map((x) => x.trim())
		.filter(Boolean)
}

function tagNamesByGroup(tags, groupName) {
	return (tags || []).filter((t) => t.group?.name === groupName || t.group_name === groupName).map((t) => t.name)
}

function flavorsFromDescription(desc) {
	const text = String(desc || '')
	if (!text) return []
	const table = skillData.flavors?.flavors || {}
	return Object.entries(table)
		.filter(([, v]) => (v.aliases || []).some((a) => text.includes(a)))
		.map(([k]) => k)
		.slice(0, 3)
}

/** Map bean record → skill PackagingInput */
export function beanToCoverInput(bean = {}, tags = null) {
	const allTags = tags || bean.tags || []
	const countries = splitMulti(bean.country)
	const country = countries[0] || ''

	let processList = splitMulti(bean.process).map((p) => PROCESS_ENUM[p] || p)
	if (bean.process === 'other' && (bean.otherprocess || bean.otherProcess)) {
		processList = [bean.otherprocess || bean.otherProcess]
	}
	const processTags = tagNamesByGroup(allTags, '处理法')
	if (!processList.length && processTags.length) processList = processTags

	let flavorList = tagNamesByGroup(allTags, '风味')
	if (!flavorList.length) flavorList = flavorsFromDescription(bean.description)

	return {
		country,
		process: processList,
		flavors: flavorList,
		altitude: bean.altitude || '',
		kind: bean.kind || 'single',
		extra: bean.name ? `inspired by SKU ${bean.name}` : ''
	}
}

/** Generate cover prompt from bean using skill JSON + prompt-builder */
export function buildCoverPromptFromBean(bean, tags) {
	return buildCoverPrompt(beanToCoverInput(bean, tags))
}
